import React from "react";
import PropTypes from "prop-types";
import produce from "immer";
import CollectionLink from "../../utils/generate-collection-link";

// import BigStoryCardCurve from "../../atoms/big-story-card-curve/index";
import ElectionStoryTwoCollectionStoryStack from "../../atoms/election-story-2c-story-stack";
import SmallStoryCardCurve from "../../atoms/small-story-card-curve";

import styles from "./styles.m.css";

import { wrapCollectionLayout } from "@quintype/components";
import { getStoryHeadline } from "../../utils/utils";
import Icon from "../../atoms/icon";

const WrappedStoryStack = wrapCollectionLayout(ElectionStoryTwoCollectionStoryStack);

const mobileStoryCount = 3;

const Election2CWithPoll = ({ collection, accentColor }) => {
  const { items } = collection;

  // Filter for sub-collections
  const subCollections = items.filter(item => item.type === "collection");

  // Prepare Collection 1 (Top Section)
  const col1Raw = subCollections[0];
  const col1 = col1Raw
    ? produce(col1Raw, draft => {
        draft.items = (draft.items || [])
          .filter(({ story = {} }) => getStoryHeadline(story) != null && story.url != null)
          .slice(0, 10); // Top section: 10 stories
      })
    : null;

  // Prepare Collection 2 (Bottom Left)
  const col2Raw = subCollections[1];
  const col2 = col2Raw
    ? produce(col2Raw, draft => {
        draft.items = (draft.items || [])
          .filter(({ story = {} }) => getStoryHeadline(story) != null && story.url != null)
          .slice(0, 8); // 2nd collection: 8 stories
      })
    : null;

  return (
    <div className={styles["base"]} style={accentColor && { "--accent-color": accentColor }}>
      <div className={`${styles["container-story"]} container`}>
        {/* Top Section */}
        {col1 && (
          <div className={styles["top-section"]}>
            <WrappedStoryStack bigStory={true} mobileStoryCount={mobileStoryCount} collection={col1} />
          </div>
        )}

        {/* Bottom Section */}
        <div className={styles["bottom-section"]}>
          {/* Left Column: Collection 2 */}
          <div className={styles["bottom-left"]}>
            {col2 && (
              <div>
                <CollectionLink collection={col2}>
                  <h2 className={styles["sub-collection-headline"]}>
                    {col2.name}
                    <div className={styles["collection-cta"]}>
                      <Icon type={"slider-next"} />
                    </div>
                  </h2>
                </CollectionLink>
                <div className={styles["story-list"]}>
                  {col2.items.map(item => (
                    <SmallStoryCardCurve
                      key={item.id}
                      story={item.story}
                      className={styles["bottom-story-card"]}
                      horizondalImage={true}
                      iconbottomright={true}
                    />
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* Right Column: Poll */}
          <div className={styles["bottom-right"]}>
            <iframe
              src="https://special.vikatan.com/vikatan-poll/election_poll.php"
              width="100%"
              height="100%"
              frameBorder="0"
              scrolling="no"
              className={styles["poll-iframe"]}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

Election2CWithPoll.propTypes = {
  accentColor: PropTypes.string,
  horizondalImage: PropTypes.bool,
  collection: PropTypes.shape({
    items: PropTypes.arrayOf(
      PropTypes.shape({
        type: PropTypes.string,
        name: PropTypes.string,
        items: PropTypes.array
      })
    )
  })
};

export default Election2CWithPoll;
